export const environment = {
  production: true,
  apiHost: 'https://api.socialauditor.io/',
  cookiesHost: '.socialauditor.io',
  mapsApiKey: 'AIzaSyC3C7Ivtse-k975QsqkZfMjaaTxV3vD2P8',
  stripeKey: 'pk_live_dVmXLorQnfpFJ7bOCKsrP64b00bO82dMgL',
  mainPage: 'https://socialauditor.io',
  facebookAppID: '2847916775299904',
  googleAppID: '508896406935-k24lgcud415qlqfh3g7gsujd7a23i3nh.apps.googleusercontent.com'
};
